import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * KA 卖场
 * 新增
 * @param {*} params
 */
export function apiKastoreAddKA(data) {
  return request({
    url: BASE_API() + '/kastore/saveKA',
    method: 'post',
    data
  })
}

/**
 * KA 卖场
 * 查询列表
 * @param {*} params
 */
export function apiKastoreList(data) {
  return request({
    url: BASE_API() + '/kastore/listKAStore',
    method: 'post',
    data
  })
}

/**
 * KA 卖场
 * 删除
 * @param {*} params
 */
export function apiKastoreDelete(params) {
  return request({
    url: BASE_API() + '/kastore/deleteById',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/applyForGoods/goods-ka.js